import './NoteInputArea.scss';
import React, { useState, useEffect } from 'react';
import { CustomButton } from '../../components/_common/CustomButton/CustomButton';

interface NoteProps {
    onSaveNote: (note: string) => void;
    onEditNote: (note: string, noteId: number) => void;
    noteText?: string;
    isEditMode?: boolean;
    onCancel?: () => void;
    noteId?: number;
}

const MAX_TEXT_LENGTH = 500;

const NoteInputArea = ({
    onSaveNote,
    onEditNote,
    noteText,
    isEditMode = false,
    onCancel,
    noteId = 0,
}: NoteProps): React.ReactElement => {
    const [note, setNote] = useState(noteText ? noteText : '');
    const [noteInputHeight, setNoteInputHeight] = useState(20);

    useEffect(() => {
        const noteTextarea = document.getElementById('note' + noteId.toString());
        if (noteTextarea) {
            setNoteInputHeight(Math.min(noteTextarea.scrollHeight));
        }
    }, [note]);

    const validateNoteText = (note: string): boolean => {
        const inputLength = note.length;
        if (inputLength === 0 || inputLength > MAX_TEXT_LENGTH) {
            return false;
        } else if (inputLength > 0 && inputLength <= MAX_TEXT_LENGTH) {
            return true;
        }
        return false;
    };
    const [isValid, setIsValid] = useState(validateNoteText(note));

    const onChange = (event: any): void => {
        const value = event.target.value;
        setIsValid(validateNoteText(value));

        setNote(value);
    };

    const onSave = (): void => {
        if (isValid) {
            onSaveNote(note);
            setNote('');
            setIsValid(false);
        }
    };

    const onEdit = (): void => {
        if (isValid) {
            onEditNote(note, noteId);
        }
    };

    return (
        <div className="NoteInputArea-Container">
            <div className="NoteInputArea-DetailsContainer">
                <span className="NoteInputArea-Text">
                    {note.length}/{MAX_TEXT_LENGTH}
                </span>
            </div>
            <textarea
                id={`note${noteId}`}
                className="NoteInputArea-InputContainer"
                style={{ height: noteInputHeight }}
                value={note}
                onChange={onChange}
            ></textarea>
            <div className="NoteInputArea-ButtonContainer">
                {!isEditMode ? (
                    <div className="NoteInputArea-ButtonStyle">
                        <CustomButton isBordered={false} isDisabled={!isValid} title="Save Note" onClick={onSave} />
                    </div>
                ) : (
                    <div className="NoteInputArea-FooterContainer">
                        <span className="NoteInputArea-Link" onClick={onCancel}>
                            Cancel
                        </span>
                        <span className="NoteInputArea-LinkDivider">|</span>
                        <span
                            className={`NoteInputArea-Link ${isValid ? '' : 'NoteInputArea-DisabledLink'}`}
                            onClick={() => {
                                onEdit();
                                onCancel && onCancel();
                            }}
                        >
                            Save
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NoteInputArea;

